// Header module exports
import { initializeMenu } from './header-menu-left.js';
import { initializeSearchBar } from './header-search-bar.js';
import { initHeaderButtons } from './header-buttons.js';
import { HEADER_VARIANT, LOGGING } from '/settings.js';

// Initialize header functionality
// CRITICAL: Header buttons (Menu, Explore, Maps) should ALWAYS be visible
// They are part of the general app UI and should NOT be removed/recreated on area changes
export async function initializeHeader(options = {}) {
    const container = document.getElementById('search-bar-container');
    if (!container) return;

    // Check if header buttons already exist
    const existingWrapper = container.querySelector('.header-toggle-btns');
    const hasButtons = existingWrapper && existingWrapper.children.length > 0;

    // If buttons already exist and we're in buttons mode, don't recreate them
    // Header buttons are persistent UI elements that should never disappear
    if (hasButtons && HEADER_VARIANT === 'buttons') {
        if (LOGGING.ENABLED && LOGGING.MENU) {
            console.log('[Header] Header buttons already exist, skipping recreation');
        }
        // Just update button states if needed (active flow, etc.)
        // But don't clear and recreate - buttons should persist!
        return;
    }

    // Only clear and recreate if:
    // 1. Buttons don't exist yet (first initialization)
    // 2. We're switching between HEADER_VARIANT modes (buttons <-> search)
    // 3. Container has unexpected content

    // 1. CRITICAL: Preserve menu toggle button BEFORE clearing container
    // The menu toggle is part of the general app UI and should NEVER be lost
    const menuToggle = document.getElementById('menu-toggle');
    const headerLeft = document.querySelector('.header-left');

    // ALWAYS ensure menu toggle is in header-left before clearing container
    if (menuToggle && headerLeft) {
        // Check if menu toggle is in the container (which will be cleared)
        const isInContainer = container.contains(menuToggle);

        // If menu toggle is in container, move it to header-left for safety
        if (isInContainer) {
            const currentParent = menuToggle.parentNode;
            // Only move if it's not already in header-left
            if (currentParent && currentParent !== headerLeft) {
                try {
                    // Remove from current parent (container or wrapper inside container)
                    currentParent.removeChild(menuToggle);
                    // Move to header-left (safe location that won't be cleared)
                    headerLeft.appendChild(menuToggle);
                } catch (error) {
                    // If removal fails, the element might have been moved already
                    if (LOGGING.ENABLED && LOGGING.MENU) {
                        console.warn('[Header] Could not move menu toggle, current parent:', menuToggle.parentNode?.id || menuToggle.parentNode?.className);
                    }
                }
            }
        }
    }

    // 2. Clear Container (Only if we need to recreate)
    // Menu toggle is now safely in header-left, so it won't be lost
    container.innerHTML = '';

    // 3. Append Query Tools (Buttons or Search Bar)
    // initHeaderButtons will find the menu toggle in header-left and move it to the wrapper
    if (HEADER_VARIANT === 'buttons') {
        await initHeaderButtons(container, options);
    } else {
        await initializeSearchBar(container);
    }
}

// Re-export everything from header components
export * from './header-menu-left.js';
export * from './header-search-bar.js';
export * from './header-search.js';
export * from './header-discover.js'; 
